import React from "react";
// components

export function Footer() {
  return (
    <footer className="footer sm:footer-horizontal footer-center bg-base-100 text-base-content p-4 shadow-sm">
      <aside>
        <p>Copyright ©{new Date().getFullYear()} - All the roosters</p>
      </aside>
    </footer>
  );
}
